import { ARTICLE_LAWYERS_LOAD_ERROR } from '@/pages/journalArticle/lib/journalArticleMessages';
import {
  RECOMMENDED_LAWYERS_PER_PAGE,
  RECOMMENDED_LAWYERS_MIN_RATING,
} from '@/pages/journalArticle/lib/useJournalArticleConstants';
import { groupLawyersByCategories } from '@/pages/journalArticle/lib/groupLawyersByCategories';

import { useGeoLocation } from '@/entities/geo/model/useGeoLocation';
import type { ILawyerCardInfo } from '@/entities/lawyer/@x/journal';
import type { ArticleLawyersSection } from '@/pages/journalArticle/model/types/articleLawyers';
import { useErrorHandler } from '@/shared/lib/errors';

const useArticleLawyers = (topicId: ComputedRef<number | undefined>) => {
  const { handleError } = useErrorHandler();
  const { $lawyerService } = useNuxtApp();
  const { getGeoSlug } = useGeoLocation();

  const lawyersSections: Ref<ArticleLawyersSection[]> = ref([]);

  const getLawyers = async (): Promise<void> => {
    if (!topicId.value) return;

    try {
      const geoSlug = await getGeoSlug();

      const response = await $lawyerService.getLawyersByTopicId<ILawyerCardInfo[]>({
        topic_id: topicId.value,
        per_page: RECOMMENDED_LAWYERS_PER_PAGE,
        page: 1,
        rating: RECOMMENDED_LAWYERS_MIN_RATING,
        rating_zero: 1,
        by_geo: geoSlug ? 1 : 0,
        without_company: 1,
      });
      const lawyers = response.data ?? [];

      lawyersSections.value = groupLawyersByCategories(lawyers, topicId.value);
    } catch (error) {
      handleError(error, {
        context: { action: ARTICLE_LAWYERS_LOAD_ERROR },
      });
    }
  };

  return {
    lawyersSections,
    getLawyers,
  };
};

export default useArticleLawyers;
